<template>
  <div class="card-container">
    <common-top-form
      :model="formModel"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      selectShowPower="/bonusplan/select"
    >
     <el-form-item label="全付宝ID">
        <el-input
          v-model="formModel.tidCode"
          placeholder="请输入ID"
        ></el-input>
      </el-form-item>
      <el-form-item label="SN">
        <el-input
          v-model="formModel.shopSncode"
          placeholder="请输入SN"
        ></el-input>
      </el-form-item>
      <el-form-item label="商户号">
        <el-input v-model="formModel.merCode" placeholder="请输入商户号"></el-input>
      </el-form-item>
     
        
         
    </common-top-form>
    <common-table
      :data="tableData"
      ref="commonTable"
      @handleSelectionChange="handleSelectionChange"
      @handleChange="getPage"
    >
      <el-table-column
        prop="merCode"
        label="平台商户号"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
       <!-- <el-table-column
        prop="tidCode"
        label="ID"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column> -->
      <el-table-column
        prop="shopSncode"
        label="平台SN"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
    
      <el-table-column
        prop="status"
        label="状态"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      >
      
        <template slot-scope="scope">
          <span v-if="scope.row.status == 0">正常</span>
          <span v-else-if="scope.row.status == 1">未开通（审核中）</span>
          <span v-else-if="scope.row.status == 2">失败</span>
        </template></el-table-column>
  <el-table-column
        prop="activeCode"
        label="上游活动编号"
        min-width="220"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
  <el-table-column
        prop="despositStatus"
        label="终端押金标识"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      >
      
        <template slot-scope="scope">
          <span v-if="scope.row.despositStatus == 0">不收</span>
          <span v-else-if="scope.row.despositStatus == 1">未收</span>
          <span v-else-if="scope.row.despositStatus == 2">已收</span>
        </template></el-table-column>
 <el-table-column
        prop="despositAmt"
        label="终端押金金额"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>

          <el-table-column
        prop="createDate"
        label="创建时间"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="操作" min-width="260" fixed="right">
        <template slot-scope="scope">
          <div style="display: flex; justify-content: center">
            <el-button type="text" @click="channelMerchant(scope.row)"
              >通道终端
            </el-button>
            <el-button type="text" @click="handleDelete(scope.row)"
              >解绑
            </el-button>
             <el-button type="text" @click="pushNew(scope.row)" v-if="scope.row.status == 0"
              >重新推送
            </el-button>
          </div>
        </template>
      </el-table-column>
    </common-table>
  </div>
</template>

<script>
import ImageViewer from "../../dialog/ImageViewer";
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import FormDialog from "../../dialog/FormDialog";
import ShowInfoDialog from "../../dialog/ShowInfoDialog";
import FinanceService from "service/FinanceService";
import StatisticsService from "service/StatisticsService";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "bonusplan",
  components: {
    CommonTopForm,
    CommonTable,
    FormDialog,
    ShowInfoDialog,
    ImageViewer,
  },
  data() {
    return {
      dialogAmount: 0,
      show: false,
      formModel: {
        merCode: "",
        tidCode: "",
        shopSncode: "",
        createDate: ''
      },
      tableData: [],
      multipleSelection: [],
      ids: [],
      submitService: FinanceService.merTidInfoList,
      itemId: "",
      page: {},
      isPage: false,
      isFlag: false,
      flag: "",
    };
  },
  inject: ["reload"],
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  mounted() {
    this.load();
  },
  computed: {
    submitData() {
      this.params = {
        merCode: this.formModel.merCode,
        tidCode: this.formModel.tidCode,
        shopSncode: this.formModel.shopSncode,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };
      return this.params;
    },
    ...mapGetters(["serverType", "tatId", "userId"]),
  },
  watch: {},
  methods: {
    channelMerchant(row) {
      this.$router.push({
        name: "ChannelTerminal",
        params: {
          item: JSON.stringify(row),
        },
      });
    },
    load() {
      this.formModel = {
        date: "",
      };
      this.page = this.$refs.commonTable.page;
      this.getList();
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          console.log(res, "resresres");
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
      let str = "";
      this.multipleSelection.forEach(function (item, index) {
        str += item.id + ",";
      });
      str = str.substring(0, str.length - 1);
      this.ids = str.split(",");
    },
    handleDelete(item) {
      this.showConfirm("是否解绑？")
        .then(() => {
          this.doDelete(item.id);
        })
        .catch(() => {});
    },
    doDelete(id) {
      this.doLoad(
        FinanceService.deleteBind,
        {
          id: id,
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.commonSuccess(res);
          });
        },
        "操作失败"
      );
    },
    pushNew(item) {
       this.showConfirm("是否重新推送？")
        .then(() => {
          this.pushNewFun(item.id);
        })
        .catch(() => {});
    },
    
    pushNewFun(id) {
      this.doLoad(
        FinanceService.pushNewButton,
        {
          id: id,
          type: 1
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.commonSuccess(res);
          });
        },
        "操作失败"
      );
    },

    commonSuccess(res) {
      this.showSuccess(res.respMsg);
      this.getList();
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res;
        this.tableData = result.contents.rows;
        this.page.currentPage = result.contents.current;
        this.page.total = result.contents.total;
        this.page.pageSize = result.contents.size;
      });
    },
 
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/POSPTerminalManagement/POSPTerminalManagement.vue